export default __webpack_public_path__ + "static/media/shankarling.b9b26418.jpg";